import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import styled from 'styled-components';

import TabHeader from './TabHeader';

const Tab = ({ children, isActive, onClick, ...rest }) =>
  <TabWrap isActive={isActive} onClick={onClick} {...rest}>
    <TabHeader narrow vertical={false}>
      {children}
    </TabHeader>
  </TabWrap>;
Tab.propTypes = {
  children: PropTypes.node.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};
Tab.defaultProps = {
  isActive: false,
};

const TabWrap = styled.div`
  opacity: ${props => props.isActive ? 1 : 0.75};

  :hover {
    cursor: pointer;
    opacity: 1;
  }
`;

const propTypes = {
  children: PropTypes.func.isRequired,
  hideTabs: PropTypes.bool,
  tabs: PropTypes.array.isRequired,
};

const defaultProps = {
  hideTabs: false,
};

const TabRow = styled.div`
  align-items: flex-start;
  flex-direction: column;
  display: ${
    props => props.hidden
      ? 'none'
      : 'flex'
    };
  padding: 0 12px;
  position: relative;
  z-index: 2;

  @media (min-width: 720px) {
    align-items: flex-end;
    flex-direction: row;
  }

  @media (min-width: 1101px) {
    padding: 0;
  }
`;

class Tabber extends PureComponent {
  constructor(props) {
    super(props);

    const activeTab = (
      this.props.tabs.find(tab => tab.isActive) || this.props.tabs[0]
    );
    this.state = {
      activeTabId: activeTab.id,
    };
  }

  getTabSwitcher = tabId => evnt => {
    evnt.preventDefault();
    this.changeTab(tabId);
  }

  changeTab = activeTabId => {
    this.setState({ activeTabId });
  }

  render() {
    return (
      <div>
        <TabRow hidden={this.props.hideTabs}>
          {this.props.tabs.map(tab =>
            <Tab
              {...tab}
              isActive={this.state.activeTabId === tab.id}
              key={tab.id}
              onClick={this.getTabSwitcher(tab.id)}
            >
              {tab.content}
            </Tab>
          )}
        </TabRow>
        {this.props.children(this.state)}
      </div>
    );
  }
}

Tabber.propTypes = propTypes;
Tabber.defaultProps = defaultProps;

export default Tabber;
